import type { FC } from "react";
import type { ContentFileDto } from "shared";
import { Icon } from "../../common/Icon";
import { PreviewAvatar } from "../shared/PreviewAvatar";
import { PreviewMedia } from "../shared/PreviewMedia";
import "./InstagramPreview.css";

interface InstagramPreviewProps {
	companyName: string;
	content: string;
	files: ContentFileDto[];
}

export const InstagramPreview: FC<InstagramPreviewProps> = ({
	companyName,
	content,
	files,
}) => {
	const username = companyName.toLowerCase().replace(/\s+/g, "");

	return (
		<div className="ig-preview">
			<div className="ig-preview__header">
				<PreviewAvatar name={companyName} size="sm" />
				<button type="button" className="ig-preview__more">
					<Icon name="more_horiz" size={20} />
				</button>
			</div>

			<PreviewMedia files={files} aspectRatio="1:1" />

			<div className="ig-preview__actions">
				<div className="ig-preview__actions-left">
					<Icon name="favorite" size={24} />
					<Icon name="chat_bubble" size={24} />
					<Icon name="send" size={24} />
				</div>
				<Icon name="bookmark" size={24} />
			</div>

			<div className="ig-preview__content">
				<div className="ig-preview__likes">1,234 likes</div>
				<div className="ig-preview__caption">
					<span className="ig-preview__username">{username}</span>{" "}
					<span className="ig-preview__text">{content}</span>
				</div>
				<div className="ig-preview__timestamp">2 hours ago</div>
			</div>
		</div>
	);
};
